import axios from 'axios'

export const addFavoriteReport = (data) => {
  return axios.put('/finance/favoriteReportMenus', data)
}

export const deleteFavoriteReport = (id) => {
  return axios.delete(`/finance/favoriteReportMenus/${id}`)
}
